const initialState = {
    num: 0,
    pokemonList: [],
    selectedPokemon: [],
    pokeOneWeakToTwo: false,
    pokeTwoWeakToOne: false,
    specificPokemon: '',
    pokeOneWeaknesses: [],
    pokeTwoWeaknesses: [],
    pokemonTeam: [],
    teamName: '',
    allPokeTeams: []
  }

export default initialState